module.exports = __webpack_public_path__ + "static/lsAppDashboard-c961c1fb9d17cc74ddb24bdbedb4536f.png";